"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/_react.default.createElement("path", {
  d: "M18.88 0H4.4a1.54 1.54 0 0 0-1.28 1.57v17.48a1.73 1.73 0 0 0 1.11 1.62l8 3.2a1.79 1.79 0 0 0 1.64-.17 1.75 1.75 0 0 0 .76-1.45v-17a1.75 1.75 0 0 0-1.1-1.63l-2.87-1.14a.25.25 0 0 1-.15-.28.26.26 0 0 1 .25-.2h7.86a.26.26 0 0 1 .26.25v16.47a.26.26 0 0 1-.26.25h-1.74a1 1 0 1 0 0 2h2a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z"
}), 'BookPages');

exports.default = _default;